import RestError from '../../../modules/app/errors';

export class WrongNumberError extends RestError {}
export class NumberExistError extends RestError {}
